import { __decorate } from "tslib";
import RoomDetails from '@sicfe/rooms/src/pages/RoomDetails.vue';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { getRawSensorData, getSensorData, getSetpointData } from '@/domains/sensorData';
const roomStore = namespace('RoomStore');
const debugStore = namespace('DebugStore');
let RoomDetail = class RoomDetail extends Vue {
    constructor() {
        super(...arguments);
        this.sensorDataGetter = {
            get: this.getSensorData,
            getRaw: this.getRawRoomSensorData,
            getSetpoints: this.getSetpointData,
        };
        this.loading = true;
    }
    getSensorData(request) {
        return getSensorData(this.controllerId, request);
    }
    getRawRoomSensorData(request) {
        return getRawSensorData(this.controllerId, request);
    }
    getSetpointData(request) {
        return getSetpointData(this.controllerId, request);
    }
    get debug() {
        return this.getDebug;
    }
    async created() {
        await this.fetchRoomDetail({
            controllerId: this.controllerId,
            roomId: this.roomId,
        });
        this.polling = setInterval(() => {
            this.fetchRoomDetail({
                controllerId: this.controllerId,
                roomId: this.roomId,
            });
        }, 10000);
        this.loading = false;
    }
    beforeDestroy() {
        clearInterval(this.polling);
    }
    get controllerId() {
        return Number(this.$route.params.id);
    }
    get roomId() {
        return Number(this.$route.params.roomId);
    }
};
__decorate([
    debugStore.Getter('debug')
], RoomDetail.prototype, "getDebug", void 0);
__decorate([
    roomStore.State('roomDetail')
], RoomDetail.prototype, "room", void 0);
__decorate([
    roomStore.Action('fetchRoomDetail')
], RoomDetail.prototype, "fetchRoomDetail", void 0);
RoomDetail = __decorate([
    Component({
        components: {
            RoomDetails,
        },
    })
], RoomDetail);
export default RoomDetail;
